import React, { createContext, useContext, useState, useEffect } from 'react';
import { settingsAPI } from '../services/api';

const SiteContext = createContext(null);

const DEFAULTS = {
  homepage_show_techniques:    '1',
  homepage_show_testimonials:  '1',
  homepage_testimonials_title: 'Ils nous font confiance',
};

export const SiteProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loaded,   setLoaded]   = useState(false);

  const fetchSettings = () =>
    settingsAPI.public()
      .then(({ data }) => { if (data.data) setSettings({ ...DEFAULTS, ...data.data }); })
      .catch(() => {});

  useEffect(() => {
    fetchSettings().finally(() => setLoaded(true));
  }, []); // eslint-disable-line

  const refresh = () => fetchSettings();

  // Normalise les booléens PHP (true/false) en strings ('1'/'0')
  const get = (key, fallback = '') => {
    const val = settings[key];
    if (val === undefined || val === null) return fallback;
    if (typeof val === 'boolean') return val ? '1' : '0';
    if (typeof val === 'number')  return String(val);
    return val !== '' ? val : fallback;
  };

  return (
    <SiteContext.Provider value={{ settings, loaded, setSettings, get, refresh }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => {
  const ctx = useContext(SiteContext);
  if (!ctx) throw new Error('useSite must be used within SiteProvider');
  return ctx;
};
